export default "__VITE_ASSET__haV6Bgq1__"